/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateInstrumentLinkNotification} from '../api'

export const useMutationGenerateInstrumentLinkNotification = createReactQueryMutationHook('generateInstrumentLinkNotification', generateInstrumentLinkNotification)
